/* global $, jQuery */
import { initFilters } from './filter.js';
import { initGallery } from './gallery.js';
import { initInquiry } from './inquiry.js';

$(function () {
  // Init filtering on category pages
  if ($('#stone-grid').length) {
    initFilters();
  }

  // Init gallery on detail pages
  if ($('.gallery').length) {
    initGallery();
  }

  // Init inquiry form modal
  initInquiry();

  // Mobile menu toggle
  $('.page-header__toggle').on('click', function () {
    var $h = $('.page-header');
    var open = $h.toggleClass('page-header--open').hasClass('page-header--open');
    $(this).attr('aria-expanded', open ? 'true' : 'false');
  });

  // Scroll-to-top button
  var $scrollTop = $('#scroll-top');
  $(window).on('scroll.scrolltop', function () {
    if ($(this).scrollTop() > 400) {
      $scrollTop.removeAttr('hidden').addClass('is-visible');
    } else {
      $scrollTop.removeClass('is-visible').attr('hidden', '');
    }
  });
  $scrollTop.on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 300);
  });
});
